const root = document.getElementById('root');

if (import.meta.env.DEV || !root?.dataset.prerendered) {
  Promise.all([
    import('react'),
    import('react-dom/client'),
    import('./App.jsx'),
  ]).then(([{ default: React }, { createRoot }, { default: App }]) => {
    createRoot(root).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
}
